import { isType } from '@mtna/core-ts';
import { Code, Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { BaseFilter } from './base-filter.model';
import { RdsNullFilter } from './null-filter.model';

/**
 *  @param variable variable to be filtered on
 *  @param codes array of {@link Code} to be filtered
 *  @param nullFilter  an {@link RdsNullFilter} parameter. Optional.
 *  @param excludeCodes boolean that determines whether the selected codes are to be excluded. Optional.
 */
export class FilterByCodes<V extends Variable | VariableSummary = Variable> extends BaseFilter<V> {
  constructor(variable: V, public codes: Array<Code>, nullFilter?: RdsNullFilter, public excludeCodes?: boolean) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByCodes(something: unknown): something is FilterByCodes<Variable | VariableSummary> {
  return isType<FilterByCodes<Variable | VariableSummary>>(something, 'variable', 'codes');
}
